export enum HABILITADO {
    TODOS = "TODOS",
    SI = "S",
    NO = "N"
}